import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Mivza } from 'src/app/Interfaces/SQL-morning-responses';
import { StoreService } from 'src/app/services/store.service';
import { ProductInfoDialogComponent } from '../product-info-dialog.component';

@Component({
	selector: 'app-mivza-popup',
	templateUrl: './mivza-popup.component.html',
	styleUrls: ['../products.component.scss'],
	styles: [
		`
			.main-menu__logo-col-title {
				color: black;
				font-size: 18px;
				margin-bottom: 20px;
			}

			@media (min-width: 768px) {
				.main-menu__logo-col-title {
					font-size: 24px;
					margin-bottom: 30px;
				}
			}
		`,
	],
})
export class MivzaPopupComponent implements OnInit {
	allMivza: Mivza[] = [];
	productName = '';

	private dialogRef = inject(MatDialogRef<MivzaPopupComponent>);

	constructor(@Inject(MAT_DIALOG_DATA) private data: { mivza: Mivza[]; productName: string }) {}

	ngOnInit(): void {
		this.allMivza = this.data.mivza;
		this.productName = this.data.productName;
	}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
